import { useCreateUserAccountSchema } from './useCreateUserAccountSchema';
import { ICreateUserAccountFormData } from '../types/ICreateUserAccountFormData';
import { useForm } from '../../../../../shared/form/useForm';

export function useCreateUserAccountForm() {
	const validationSchema = useCreateUserAccountSchema();
	const form = useForm<ICreateUserAccountFormData>({
		mode: 'onSubmit',
		validationSchema,
	});

	return form;
}
